import {Component, Input, OnInit} from '@angular/core';
import {League} from "@api/models/league/league";
import {UrlService} from "@utils/services/url/url.service";
import {LeagueHttpService} from "@api/http/league/league-http.service";
import {LeagueStatisticType} from '@api/models/statistics/league-statistic-type';
import {ILeagueStatistic} from '@api/models/statistics/league-statistics-response';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';

@Component({
  selector: 'lib-league-statistics-table',
  templateUrl: './league-statistics-table.component.html',
  styleUrls: ['./league-statistics-table.component.scss']
})
export class LeagueStatisticsTableComponent implements OnInit {

  @Input() public type = LeagueStatisticType.Goals;
  @Input() public league: League;
  @Input() public limit: number;
  @Input() public layout: 'web' | 'krone' = 'web';
  @Input() public statistic: ILeagueStatistic;
  @Input() public openLinksInNewTab = true;
  @Input() public colorScheme = ColorScheme.Default;
  public getLink = UrlService.getSubdomainUrl;
  public types = LeagueStatisticType;

  constructor( private leagueHttpService: LeagueHttpService ) { }

  public async ngOnInit(): Promise<void> {
    if (!this.statistic) {
      this.statistic = await this.leagueHttpService.getStatistic(this.league._id, this.type);
    }
    if (this.limit) {
      this.statistic.stats = this.statistic.stats.slice(0, this.limit);
    }
  }

  public onScorerClick(teamRid: string): void {
    if (!teamRid) {
      return;
    }
    window.open(this.getLink(teamRid), this.openLinksInNewTab ? '_blank' : '_self');
  }

}
